<template>
  <div class="chat-message-input">
    <div class="chat-message-input-icon-box">
      <el-popover style="position: relative !important" v-model="showPopover" placement="top-start" width="200" trigger="click" :append-to-body="false">
        <emoji @select-emoji="selectEmoji" />
        <button slot="reference" type="button" class="m-btn m-btn-default m-btn-sm">
          <span role="img" tabindex="-1" class="anticon chat-message-input-icon-emoji">
            <svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" class="iconpark-icon">
              <use href="#slightly-smiling-face"></use>
            </svg>
          </span>
        </button>
      </el-popover>
      <button type="button" class="m-btn m-btn-default m-btn-sm" @click="triggerFileInput">
        <input type="file" ref="fileInput" id="fileInput" style="display: none" @change="handleFileChange" />
        <span role="img" tabindex="-1" class="anticon chat-message-input-icon-emoji">
          <svg class="iconpark-icon"  width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false"><use href="#folder-close"></use></svg>
        </span>
      </button>
    </div>
    <div class="chat-message-input-wrap">
      <div class="chat-message-input-popup-container"></div>
      <div class="chat-message-input-content">
        <textarea v-model="msg" @keydown.enter="handleKeyDown" ref="chatInput" :placeholder="placeholder" :disabled="disabled" class="m-input ant-input-borderless chat-message-input-textarea" style="overflow-y: auto; height: 130px; resize: none; max-height: 150px;"></textarea>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import Coze from '../../../../coze';
import Emoji from './Emoji'
export default {
  name: 'ChatInput',
  components: {
    Emoji
  },
  props: {
    followUpActiveText: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapState({
      activeAccount: state => state.imActiveAccount,
      imMessages: state => state.imMessages,
      botFollowUp: state => state.botFollowUp,
      botChunkIng: state => state.botChunkIng,
      imAccount: state => state.imAccount,
      imTeams: state => state.imTeams
    }),
    team () {
      return this.imTeams[this.activeAccount.to]
    }
  },
  watch: {
    team: {
      handler (newValue) {
        if (newValue) this.checkStatue(newValue)
      },
      immediate: true,
      deep: true
    },
    followUpActiveText (newValue) {
      if (newValue) {
        this.msg = newValue
        this.bot()
      }
    },
    activeAccount (newValue) {
      if (newValue.to !== '7380252502656237619') {
        this.$store.commit('setBotFollowUpMutation', [])
        this.$store.commit('setBotChunkIngMutation', false)
        this.disabled = false
        this.placeholder = ''
        this.stopStream()
      }
    }
  },
  data () {
    return {
      showPopover: false,
      msg: '',
      parentElement: null,
      placeholder: '',
      disabled: false,
      streamController: null
    }
  },
  methods: {
    ...mapActions(['sendMessage', 'sendFile']),
    checkStatue (team) {
      console.log('team-ddd', this.team)
      this.placeholder = team.validToCurrentUser ? '' : '无法在已退出的群聊中发送消息'
      this.disabled = !team.validToCurrentUser
    },
    handleKeyDown (event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        event.preventDefault()
        if (this.msg.trim() !== '') {
          if (this.activeAccount.to === '7380252502656237619') {
            this.bot()
            return
          }
          this.handleSendMsg()
        }
      }
    },
    selectEmoji (emoji) {
      this.msg += emoji
      this.showPopover = false
      this.$refs['chatInput'].focus()
    },
    async handleSendMsg () {
      try {
        await this.sendMessage({
          text: this.msg
        })
        this.msg = ''
        console.log('imMessages', this.$store.state.imMessages)
      } catch (error) {
        console.error('发送消息失败', error)
      }
    },
    bot () {
      this.$store.commit('setBotFollowUpMutation', [])
      this.$store.commit('setBotChunkIngMutation', true)
      this.disabled = true
      this.placeholder = '消息加载中...'
      this.streamController = new AbortController()
      let msgObj = {
        scene: 'p2p',
        from: this.imAccount.im_accid,
        fromNick: this.imAccount.im_name,
        to: this.activeAccount.to,
        text: this.msg,
        type: 'bot',
        time: Date.now()
      }
      console.log('正在发送p2p bot消息, id=' + msgObj.to)
      this.$store.commit('addImMessageMutation', msgObj)
      this.$store.commit('imMsgListToBottomMutation', true)

      let headers = {
        Authorization: 'Bearer pat_iblczK6tLDBaD8pYbZUxXPIYSmUXPfR0TyKxhNZHpgDDlXbpvKq29mPt803skgWN'
      }

      const chats = this.botChatHistory()
      let sendData = {
        // conversation_id: '88fad35bd58248cb96991e41011cccbf',
        bot_id: '7380252502656237619',
        user: this.imAccount.im_accid,
        query: this.msg,
        chat_history: chats,
        stream: true
      }
      Coze.stream('https://api.coze.cn/open_api/v2/chat', sendData, headers, this.handleStreamData, this.handleStreamError, this.streamController)
      this.msg = ''
    },
    stopStream () {
      if (this.streamController) {
        this.streamController.abort()
        this.streamController = null
      }
    },
    botChatHistory () {
      return this.imMessages.map(item => {
        let role = item.from === '7380252502656237619' ? 'assistant' : 'user'
        return { role: role, type: role === 'assistant' ? 'answer' : 'query', content: item.text, content_type: 'text' }
      })
    },
    handleStreamData (chunk) {
      console.log('chunk', chunk)
      if (!this.botChunkIng) return
      if (chunk.event === 'done') {
        this.disabled = false
        this.placeholder = ''
        return
      }

      let index = this.imMessages.findIndex(message => {
        return message.conversation_id && message.conversation_id === chunk.conversation_id
      })
      if (index !== -1 && chunk.message.type === 'answer') {
        this.imMessages[index].text += chunk.message.content
        this.$store.commit('imMsgListToBottomMutation', true)
      }

      if (index === -1 && chunk.message.type === 'answer' && chunk.message.content_type === 'text') {
        console.log('dddddddd', chunk)
        this.$store.commit('addImMessageMutation', {from: '7380252502656237619', fromNick: 'cozeAI', text: chunk.message.content, type: 'bot', time: Date.now(), conversation_id: chunk.conversation_id, index: chunk.index})
        this.$store.commit('imMsgListToBottomMutation', true)
      }

      if (chunk.message && chunk.message.type === 'follow_up') {
        this.$store.commit('addBotFollowUpMutation', chunk.message.content)
        this.$store.commit('imMsgListToBottomMutation', true)
      }

      // if (chunk.event === 'done') {
      //   this.disabled = false
      //   this.placeholder = ''
      // }
    },
    handleStreamError (error) {
      console.error('Error fetching stream data:', error)
    },
    triggerFileInput () {
      this.$refs.fileInput.click()
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      console.log(file)
      if (file) {
        let blobUrl = URL.createObjectURL(file)
        let fileType = this.getFileType(file.type)
        console.log(blobUrl)
        this.sendFile({ domId: 'fileInput', blobUrl: blobUrl, type: fileType, name: file.name, size: file.size, done: this.uploadDone })
        // this.$refs.fileInput.value = ''
      } else {
        console.log('选择文件失败')
      }
    },
    getFileType (type) {
      if (type.startsWith('image/')) return 'image'
      if (type.startsWith('audio/')) return 'audio'
      if (type.startsWith('video/')) return 'video'

      return 'file'
    },
    uploadDone (err, msg) {
      if (err) {
        console.log('发送失败', err)
      } else {
        console.log('发送消息成功，消息为: ', msg)
        console.log('发送消息成功', this.$store.state.imMessages)
      }
      this.$store.dispatch('updateMsgInMsgArr', msg)
      this.$refs.fileInput.value = ''
    }
  },
  mounted() {
  }
}
</script>

<style lang="stylus" scoped>
  .chat-message-input {
    padding: 16px 16px 5px 16px;
    border-top: 1px solid #ded9d9;
  }
  .chat-message-input-wrap {
    position: relative;
    border-radius: 4px;
  }
  .chat-message-input-wrap .chat-message-input-popup-container {
    position: absolute;
    top: 15px;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .chat-message-input-wrap .chat-message-input-content {
    display: flex;
    position: relative;
  }
  .m-input {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    font-variant: tabular-nums;
    list-style: none;
    font-feature-settings: 'tnum';
    position: relative;
    display: inline-block;
    width: 100%;
    min-width: 0;
    color: rgba(0, 0, 0, 0.85);
    font-size: 14px;
    line-height: 1.5715;
    background-color: #fff;
    background-image: none;
    border: 1px solid #d9d9d9;
    border-radius: 2px;
    transition: all 0.3s;
  }
  .m-input:placeholder-shown {
    text-overflow: ellipsis;
  }
  .chat-message-input-wrap .chat-message-input-textarea {
    resize: none;
    line-height: 22px;
    border: none;
    outline: none;
    background-color: #f3f3f3;
  }
  textarea.m-input {
    max-width: 100%;
    height: auto;
    min-height: 32px;
    line-height: 1.5715;
    vertical-align: bottom;
    transition: all 0.3s, height 0s;
  }
  .chat-message-input-icon-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .m-btn {
    line-height: 1.5715;
    position: relative;
    display: inline-block;
    font-weight: 400;
    white-space: nowrap;
    text-align: center;
    background-image: none;
    border: 1px solid transparent;
    box-shadow: 0 2px 0 rgba(0, 0, 0, 0.015);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    user-select: none;
    touch-action: manipulation;
    height: 32px;
    padding: 4px 15px;
    font-size: 14px;
    border-radius: 2px;
    color: rgba(0, 0, 0, 0.85);
  }
  .m-btn-sm {
    height: 24px;
    padding: 0 7px;
    font-size: 14px;
    border-radius: 2px;
  }
  .chat-message-input-icon-box .m-btn {
    padding: 0;
    border: none;
    height: auto;
    margin-right: 12px;
    background: none;
  }
  .chat-message-input-icon-box .chat-message-input-icon-emoji {
    font-size: 20px;
  }
  .anticon svg {
    display: inline-block;
  }
  .chat-message-input-icon-box >>> .el-popover {
    position: absolute !important;
    //top: -55px !important;
    left: -5px !important;
  }
</style>



// WEBPACK FOOTER //
// src/common/im/right/chat/ChatInput.vue